import { ActionPlanItem, ActionPlanItemWithStep } from 'types/ActionPlan';

export const getActionsForSubMetric = (
  actions: ActionPlanItem[],
  subMetricId?: number | string,
): ActionPlanItemWithStep[] => {
  if (!subMetricId) return actions;
  const numericIdToUse =
    typeof subMetricId === 'string' ? parseInt(subMetricId) : subMetricId;
  return actions.reduce<ActionPlanItemWithStep[]>((acc, item) => {
    const matchesMetric = item.desired_outcomes?.some(
      outcome =>
        outcome.section === 'Gut Vaginal Health' &&
        outcome.gut_vaginal_health?.id === numericIdToUse,
    );
    if (matchesMetric) {
      // An item can belong to several steps (one per outcome). Its canonical
      // step is the lowest, matching how the Action Plan page dedupes.
      const [canonical] = (item.desired_outcomes ?? [])
        .map(outcome => outcome.outcomes_category_kit)
        .filter(
          (
            category,
          ): category is {
            kit_id: string;
            action_category_number: number;
            action_category_text?: string;
          } => category?.action_category_number != null,
        )
        .sort((a, b) => a.action_category_number - b.action_category_number);
      acc.push({
        ...item,
        step: canonical?.action_category_number,
        stepText: canonical?.action_category_text,
      });
    }
    return acc;
  }, []);
};
